import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple"> Hammad Habib </span>
            from <span className="purple"> <a className="purple" style={
        {textDecoration: "none"}
            } href="https://www.google.com/search?q=Karachi&oq=Karachi&gs_lcrp=EgRlZGdlKgwIABBFGDkYsQMYgAQyDAgAEEUYORixAxiABDIKCAEQABixAxiABDIGCAIQRRg7MgoIAxAAGLEDGIAEMgoIBBAAGLEDGIAEMgcIBRAAGIAEMgcIBhAAGIAEMgcIBxAAGIAEMgoICBAAGLEDGIAE0gEIMjQzMmowajGoAgCwAgA&sourceid=chrome&ie=UTF-8">Karachi</a>, Pakistan.</span>
            <br />
            I am currently employed as a Frontend Developer.
            <br />
            I have completed Integrated BSc (Hons) in Computer Science at Bahria University
            Islamabad.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Gymming
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          {/* <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p> */}
          <footer className="blockquote-footer">Hammad Habib</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
